import tinycolor from 'tinycolor2'
import { Fill, Stroke, Style } from 'ol/style'

import { genericStyles } from '../../genericStyles'

const trafficAreaMarkerStylesCache: Map<string, Style> = new Map()

/**
 * Return the right style to be used by a Traffic area feature
 */
export function getTrafficAreaFeatureStyle(
  marker: uui.domain.ui.map.markers.Area,
  mode: uui.domain.ui.map.markers.MapStyles['trafficProfile']['mode'],
  selected: boolean = false,
) {
  if (mode === 'off') return genericStyles.hidden

  const cacheId = `${marker.color}_${selected ? 1 : 0}`

  if (trafficAreaMarkerStylesCache.has(cacheId)) {
    const cachedStyle = trafficAreaMarkerStylesCache.get(cacheId)
    if (cachedStyle) return cachedStyle
  }

  const { r, g, b } = tinycolor(marker.color).toRgb()

  const style = new Style({
    stroke: new Stroke({
      width: 2,
      color: selected ? '#6598f0' : [r, g, b, 1],
    }),

    fill: new Fill({
      color: [r, g, b, 0.4],
    }),
  })

  trafficAreaMarkerStylesCache.set(cacheId, style)

  return style
}
